import personRnr from './person-rnr'
import enterpriseRnr from './enterprise-rnr'
import personMarkup from './person-markup'
import enterpriseMarkup from './enterprise-markup'
import login from './login'
import bind from './bind'
import search from './search'
import authLogin from './authLogin'
import ciamLogin from './ciamLogin'

export default [
  personRnr,
  enterpriseRnr,
  personMarkup,
  enterpriseMarkup,
  login,
  bind,
  search,
  authLogin,
  ciamLogin
]



// WEBPACK FOOTER //
// ./src/router/asyncRouter.js